/**
 * temporary fix
 * todo cover.lv remove this code
 * @see https://github.com/web3-wallet/web3-wallet/pull/32
 */
import { MetaMask } from '@react-web3-wallet/metamask';
function detectEip6963Providers(timeout = 200) {
    return new Promise((resolve) => {
        let providers = [];
        const onAnnouncement = (event) => {
            // Prevent adding a provider if it already exists in the list based on its uuid.
            if (providers.some((p) => p.info.uuid === event.detail.info.uuid))
                return;
            // Add the new provider to the list and call the provided callback function.
            providers = [...providers, event.detail];
        };
        setTimeout(() => {
            window.removeEventListener('eip6963:announceProvider', 
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            onAnnouncement);
            resolve(providers);
        }, timeout);
        if (typeof window !== 'undefined') {
            window.addEventListener('eip6963:announceProvider', 
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            onAnnouncement);
            window.dispatchEvent(new Event('eip6963:requestProvider'));
        }
    });
}
export class MetaMaskWithEIP6963 extends MetaMask {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async detectProvider(...args) {
        if (this.provider)
            return this.provider;
        const providers = await detectEip6963Providers();
        const metamaskProvider = providers.find((v) => v.info.rdns === 'io.metamask');
        if (metamaskProvider) {
            this.provider = metamaskProvider.provider;
            return this.provider;
        }
        return super.detectProvider(...args);
    }
}
